<div class="app-job-schedule"
     data-testid="job-schedule-container">
  <div class="top-header">
    <div class="title-container">
      <div class="header-lg-bold"
           data-testid="job-schedule-title">{{title}}</div>
      <online-indicator></online-indicator>
    </div>
    <div class="subtitle-container">
      <time [attr.datetime]="today | date:'yyyy-MM-dd'">
        <a class="title-header-date"
           data-testid="job-schedule-text-date"> {{ today | date:'EEEE, MMMM dd' }}</a>
      </time>
      <app-background-refresh-indicator [active]="isRefreshingInBackground()" />
    </div>
  </div>
  <div class="job-container">
    @if (dataLoaded && metadataExists) {
      <div class="job-schedule"
           data-testid="job-schedule-list">
        <!-- ============ READY ============ -->
        <div class="ready-section"
             [appDataUpdatedFade]="dataUpdatedPulse()"
             data-testid="job-schedule-section-ready">
          <div class="section-title">Ready</div>

          <ng-container *ngIf="readyInspections().length > 0; else noReadyBlock">
            <div class="inspection-card"
                 [ngClass]="status(item).toLocaleLowerCase()"
                 *ngFor="let item of readyInspections(); trackBy: trackById"
                 data-testid="job-schedule-card-ready">
              <div class="card-header">
                <p class="meta">
                  <span class="body-sm-regular">
                    Scheduled:
                  </span>
                  <time [attr.datetime]="item.scheduledDate | date:'yyyy-MM-dd'">
                    <a class="body-sm-regular"> {{ item.scheduledDate | date:'MMM dd' }}</a>
                  </time>
                </p>
                @switch (status(item)) {
                  @case (jobStatusEnum.CompleteUploaded) {
                    <p-tag severity="success"
                           class="status-tag"
                           [rounded]="true"
                           (click)="viewJobSyncStatus(item)"
                           data-testid="job-schedule-badge-uploaded">
                      <i class="pi pi-check-circle"></i>
                      Uploaded
                    </p-tag>
                  }
                  @case (jobStatusEnum.CompleteInProgress) {
                    <p-tag severity="info"
                           class="status-tag"
                           [rounded]="true"
                           (click)="viewJobSyncStatus(item)"
                           data-testid="job-schedule-badge-upload-in-progress">
                      <i class="pi pi-sync"></i>
                      Upload in Progress
                    </p-tag>
                  }
                  @case (jobStatusEnum.CompletePending) {
                    <p-tag severity="info"
                           class="status-tag"
                           [rounded]="true"
                           (click)="viewJobSyncStatus(item)"
                           data-testid="job-schedule-badge-upload-pending">
                      <i class="pi pi-sync"></i>
                      Upload in Progress
                    </p-tag>
                  }
                  @case(jobStatusEnum.CompleteOffline) {
                    <p-tag severity="warn"
                           class="status-tag"
                           [rounded]="true"
                           (click)="viewJobSyncStatus(item)"
                           data-testid="job-schedule-badge-upload-offline">
                      <i class="pi pi-sync"></i>
                      Upload Pending
                    </p-tag>
                  }
                  @case (jobStatusEnum.Overdue) {
                    <p-tag severity="danger"
                           class="status-tag"
                           [rounded]="true"
                           (click)="viewJobSyncStatus(item)"
                           data-testid="job-schedule-badge-overdue">
                      <i class="pi pi-exclamation-circle"></i>
                      Overdue
                    </p-tag>
                  }
                }
              </div>
              <div class="address">
                <p class="primary-display-value">{{ getPrimaryDisplayValue(item) }}</p>
                <p class="secondary-display-value">{{ item.salesCommunityName }}&nbsp;&middot; {{ getSecondaryDisplayValue(item) }}</p>
              </div>

              @switch (status(item)) {
                @case (jobStatusEnum.Ready) {
                  <p-button severity="primary"
                            styleClass="bqa-primary-btn p-button-sm p-fullwidth-button"
                            (click)="startInspection(item)"
                            data-testid="job-schedule-btn-start">
                    <a class="body-md-bold">
                      {{ item.hasStarted ? 'Continue' : 'Start Now' }}
                    </a>
                  </p-button>
                }
                @case (jobStatusEnum.Overdue) {
                  <p-button severity="primary"
                            styleClass="bqa-primary-btn p-button-sm p-fullwidth-button"
                            (click)="startInspection(item)"
                            data-testid="job-schedule-btn-start-overdue">
                    <a class="body-md-bold">
                      {{ item.hasStarted ? 'Continue' : 'Start Now' }}
                    </a>
                  </p-button>
                }

                @case (jobStatusEnum.CompleteInProgress){
                  <p-button severity="secondary"
                            styleClass="bqa-secondary-btn p-button-sm p-fullwidth-button"
                            (click)="viewReport(item)"
                            data-testid="job-schedule-btn-view-report">
                    <a class="body-md-medium"> View Report </a>
                  </p-button>
                }
                @case (jobStatusEnum.CompletePending){
                  <p-button severity="secondary"
                            styleClass="bqa-secondary-btn p-button-sm p-fullwidth-button"
                            (click)="viewReport(item)"
                            data-testid="job-schedule-btn-view-report">
                    <a class="body-md-medium"> View Report </a>
                  </p-button>
                }
                @case (jobStatusEnum.CompleteUploaded) {
                  <p-button severity="secondary"
                            styleClass="bqa-secondary-btn p-button-sm p-fullwidth-button"
                            (click)="viewReport(item)"
                            data-testid="job-schedule-btn-view-report">
                    <a class="body-md-medium"> View Report </a>
                  </p-button>
                }
                @case(jobStatusEnum.CompleteOffline) {
                  <p-button severity="secondary"
                            styleClass="bqa-secondary-btn p-button-sm p-fullwidth-button"
                            (click)="viewReport(item)"
                            data-testid="job-schedule-btn-view-report">
                    <a class="body-md-medium"> View Report </a>
                  </p-button>
                }
              }
            </div>
          </ng-container>

          <ng-template #noReadyBlock>
            <div class="no-ready"
                 data-testid="job-schedule-container-no-ready">
              <div class="no-ready-icon">
                <img src="assets/icons/celebration.svg"
                     alt="You're All Caught Up!"
                     class="celebration-icon">
              </div>
              <div class="headline">You're All Caught Up!</div>
              <div class="subtext">No inspections are ready to start.</div>
            </div>
          </ng-template>
        </div>
        <img *ngIf="upcomingInspections().length == 0 && readyInspections().length == 0"
             class="upcoming-divider"
             src="/assets/icons/divider.svg"
             alt="You're Online" />
        <!-- ============ UPCOMING ============ -->
        <div class="upcoming-section"
             [appDataUpdatedFade]="dataUpdatedPulse()"
             data-testid="job-schedule-section-upcoming">
          <div class="section-title">Upcoming</div>

          <ng-container *ngIf="upcomingInspections().length > 0; else noUpcomingBlock">
            <div class="inspection-card"
                 ngClass="upcoming"
                 *ngFor="let item of upcomingInspections(); trackBy: trackById"
                 data-testid="job-schedule-card-upcoming">
              <!-- meta line -->
              <p class="meta">
                <a class="body-sm-regular">Scheduled:</a>
                <time [attr.datetime]="item.scheduledDate | date:'yyyy-MM-dd'">
                  <a class="body-sm-regular"> {{ item.scheduledDate | date:'MMM dd' }}</a>
                </time>
              </p>

              <div class="upcoming-address">
                <p class="primary-display-value">{{ getPrimaryDisplayValue(item) }}</p>
                <p class="secondary-display-value">{{ item.salesCommunityName }}&nbsp;&middot; {{ getSecondaryDisplayValue(item) }}</p>
              </div>

              <div class="pill pill--locked"
                   data-testid="job-schedule-badge-locked">
                <i class="pi pi-lock"></i>
                <a class="body-sm-bold">Ready&nbsp;{{ item.readyForInspectionDate | date:'MMM dd' }}</a>
              </div>
            </div>
          </ng-container>

          <ng-template #noUpcomingBlock>
            <div class="no-upcoming"
                 data-testid="job-schedule-container-no-upcoming">
              <div class="no-upcoming__headline">We'll show upcoming homes here
                once assigned.</div>
            </div>
          </ng-template>
        </div>
      </div>
    } @else {
      <!-- Skeleton loaders -->
      <div class="ready-section">
        <div class="skeleton-container"
             data-testid="job-schedule-skeleton">
          <app-job-skeleton></app-job-skeleton>
          <app-job-skeleton></app-job-skeleton>
          <app-job-skeleton></app-job-skeleton>
          <app-job-skeleton></app-job-skeleton>
        </div>
      </div>
    }
    <app-support-footer></app-support-footer>

  </div>

  <app-bottom-sheet [(isOpen)]="isBottomSheetOpen"
                    [contentTemplate]="jobSyncStatusTemplate"
                    [preventOverlayClose]="false"
                    [hasFooter]="false"
                    [isFullScreen]="false" />
</div>

<ng-template #jobSyncStatusTemplate>
  <job-sync-status-drawer [jobId]="selectedJob ? selectedJob.id : null"
                          [jobMetadata]="selectedJob ? syncMetadata[selectedJob.id] : null"
                          [jobStatus]="selectedJob ? status(selectedJob) : null"
                          [overdueJobRoute]="selectedJob ? getOverdueJobRoute(selectedJob) : null"
                          [jobActionName]="'Confirmation'"
                          (onSyncSheetClose)="onSyncSheetClose()" />
</ng-template>